import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
const { app } = window;

function addPreview(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	vuw.add("preview", {
		selector() {
			return $("<div/>").addClass("preview").attr("id", "preview")
			.appendTo(this.container.$self);
		},
		
		onReady() {
			this.get("dataContent").setModule(app.module);
		},
		
		preview: {},
		
		async refresh() {
			this.$self.attr( "data-pv", app.module.getDataKey() );
			
			!!this.preview.$frame && this.preview.$frame.remove();
			
			Object.keys(this.preview).forEach(k => {
				delete this.preview[k];
			});
			
			this.preview.hasTemplate = !!app.module.template;
			
			if(!this.preview.hasTemplate) {
				this.get("dataContent").refresh();
				return true;
			}
			
			// [プレビュー用のフレームを生成]
			return new Promise(resolve => this.initPreview(() => {
				this.get("dataContent").refresh(app.module.template);
				resolve();
			}));
		},
		
		initPreview(callback) {
			// [create iframe]
			this.preview.$frame = $("<iframe/>").attr({
				name: "preview"
			}).on("load", e => {
				this.preview.window = e.target.contentWindow;
				this.preview.window.document.title = e.target.name;
				this.preview.$document = $(this.preview.window.document);
				this.preview.$body = $(this.preview.window.document.body)
				.addClass(`${document.body.className} is-ready`);
				
				// スタイルシートの設定
				let styleSheet;
				const { preview } = app.module.config;
				if(
					u_.isObject(preview) &&
					u_.isString(preview.styleSheet) &&
					preview.styleSheet
				) {
					// configに指定されている場合はそれを使用
					styleSheet = preview.styleSheet.replace(/\{root\}/g, app._relativePath);
					
				} else {
					// 未指定の場合は現在ページと同じスタイルを適用
					styleSheet = "./index.css";
				}
				
				delete app._imports[this.preview.window.name];
				app.require(styleSheet, {
					doc: this.preview.window.document,
					type: "stylesheet"
				});
				
				u_.isFunction(callback) && callback();
			}).appendTo(this.$self);
			
			return this;
		},
		
		async update(item) {
			if( u_.isObject(item) ) {
				// フレームサイズを初期化
				this.preview.$frame.css({
					"height": "",
					"max-width": ""
				});
				
				// initList
				await this.get("dataContent").initList([item]);
				
				// フレームサイズを固定
				this.preview.$frame.css({
					"height": this.preview.$document.outerHeight(true),
					"max-width": this.get("dataContent").$self.outerWidth(true)
				});
				
				return true;
				
			} else {
				return false;
			}
		}
	}, function() {
		// [add child vuw]
		this
		.add("dataContent", {
			vuwType: "colony",
			module: null,	// containerのonReadyでセットされる
			autoLoad: false,
			minimumRenderingTime: 0,
			
			// ページャーの表示・非表示
			showPager: false,
			
			refresh(templateHtml) {
				this.$self = false;
				
				this.removeReplicants().setArticleTemplate(templateHtml);
				
				if(templateHtml) {
					this.$self = $("<div/>").addClass("content")
					.appendTo(this.container.preview.$body);
					
					if(!this.$replicantTemplate) {
						$("<div/>").append(
							$("<h2/>").css("text-align", "center").text("no template.")
						).appendTo(this.$self);
					}
					
					return true;
				}
				
				return false;
			},
			
			// 記事表示用の関数（未指定の場合はテンプレートから生成）
			initArticle(item, config, $artcl, module, vuwReplicant) {
				const cb = {
					byDk: app.setPreviewCallBacks[ module.getDataKey() ],
					always: app.setPreviewCallBacks.always
				};
				
				$artcl.find("a").attr("target", "_blank");
				
				// 画像の読込完了時にコールバックを実行
				this.promiseList.push(
					vuwReplicant.getImageLoadPromise().then(async () => {
						const images = u_.getAsArray( $artcl.find("img") );
						await Promise.all( images.map(img => new Promise(resolve => {
							img.complete ? resolve() : $(img).on("load", resolve);
						})) );
						
						if( u_.isFunction(cb.byDk) ) {
							const res = await cb.byDk.call(module, $artcl, item, config);
							if(res === false) {
								return res;
							}
						}
						
						if( u_.isFunction(cb.always) ) {
							const res = await cb.always.bind(module, $artcl, item, config);
							if(res === false) {
								return res;
							}
						}
						
						return true;
					})
				);
			},
			
			// override initList
			async initList() {
				this.promiseList = [];
				await Klass(this.klass).prototype.initList.apply(this, arguments);
				return Promise.all(this.promiseList);
			}
		});
		
		// appから直接アクセス可能にする
		app.preview = this.preview;
	});
}

export default addPreview;
